import { render, staticRenderFns } from "./warehouseFee.vue?vue&type=template&id=06006603&scoped=true&"
import script from "./warehouseFee.vue?vue&type=script&lang=js&"
export * from "./warehouseFee.vue?vue&type=script&lang=js&"
import style0 from "./warehouseFee.vue?vue&type=style&index=0&id=06006603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06006603",
  null
  
)

export default component.exports